import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// import { ListingCarouselEmbedded } from '@adc/ui-adc'
import { ListingCarouselEmbedded } from '@adc/ui-adc/components/listingCarouselEmbedded';
import * as graph from '@adc/sdk';
import { getWebComponentName } from '../utils';
import '../types';
import { useGeoLocation } from '../hooks/useGeoLocation';
import { useUserAndFlags } from '../hooks/useUserAndFlags';
import { showcaseListingsFlag, showcasePropertiesFlag } from '../constants';
const getShowcaseListings = (featureFlags, listingShowcaseKey) => {
    let showcaseListings;
    const showcaseListingsFlagValue = featureFlags?.[showcaseListingsFlag];
    if (showcaseListingsFlagValue) {
        showcaseListings = showcaseListingsFlagValue[listingShowcaseKey];
    }
    if (!showcaseListings) {
        throw new Error(`Invalid listingShowcaseKey: ${listingShowcaseKey}`);
    }
    return showcaseListings;
};
const getShowcaseProperties = (featureFlags, propertyShowcaseKey) => {
    let showcaseProperties;
    const showcasePropertiesFlagValue = featureFlags?.[showcasePropertiesFlag];
    if (showcasePropertiesFlagValue) {
        showcaseProperties = showcasePropertiesFlagValue[propertyShowcaseKey];
    }
    if (!showcaseProperties) {
        throw new Error(`Invalid propertyShowcaseKey: ${propertyShowcaseKey}`);
    }
    return showcaseProperties;
};
const WrappedComponent = ({ queryType, listingShowcaseKey, propertyShowcaseKey, filters, }) => {
    const geo = useGeoLocation();
    const { user, featureFlags } = useUserAndFlags();
    console.log('Rendering ListingCarousel with user:', user); // eslint-disable-line no-console
    try {
        let showcaseListings;
        let showcaseProperties;
        if (listingShowcaseKey) {
            showcaseListings = getShowcaseListings(featureFlags, listingShowcaseKey);
        }
        else if (propertyShowcaseKey) {
            showcaseProperties = getShowcaseProperties(featureFlags, propertyShowcaseKey);
        }
        else if (!queryType) {
            throw new Error('queryType, listingShowcaseKey or propertyShowcaseKey is required');
        }
        if (filters) {
            if (filters.state && filters.state.length > 2) {
                throw new Error('State filter should be a 2-letter state code');
            }
            if (filters.tags && filters.tags.length < 1) {
                throw new Error('Tags filter should be an array of strings');
            }
            // check if productTypes is an array of ProductType
            if (filters.productTypes &&
                !filters.productTypes.every(type => Object.values(graph.enums.ProductType).includes(type))) {
                throw new Error(`ProductTypes filter should be one of ${Object.values(graph.enums.ProductType).join(', ')}`);
            }
            if (filters.omitSellerCodes && filters.omitSellerCodes.length < 1) {
                throw new Error('omitSellerCodes filter should be an array of strings');
            }
        }
        return (React.createElement(ListingCarouselEmbedded, { queryType: queryType, showcaseListings: showcaseListings, showcaseProperties: showcaseProperties, featureFlags: featureFlags, 
            // @ts-ignore next
            coordinates: geo.coordinates, elmId: 'dk_listing_carousel', targetHost: window?.CONFIGS?.AUCTIONCOM_HOST, filters: filters, hasAuthenticatedUser: user?.logged_in }));
    }
    catch (e) {
        if (e instanceof Error) {
            console.error(e.toString());
        }
        else {
            console.error(String(e));
        }
        return (
        // fail gracefully
        React.createElement("div", { style: { fontSize: '16px', color: '#97a0a6', textAlign: 'center' } }, "Featured listings coming soon..."));
    }
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        queryType: 'string',
        listingShowcaseKey: 'string',
        propertyShowcaseKey: 'string',
        filters: 'json',
    },
});
customElements.define(getWebComponentName('listing-carousel'), WebButton);
